import React, { PureComponent } from 'react'
import { Button, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import ReactCountryFlag from 'react-country-flag'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { getUser } from '../../actions/users'
import {
  DATE_FORMAT,
  TX_PHASE_IDENTITY,
  TX_STATUS_CUSTOMER_REVIEW,
  TX_STATUS_HOLD,
  TX_STATUS_POST_PROCESSING,
  TX_STATUS_PROCESSING,
} from '../../config'
import { formatTimeString } from '../../utils/formatters'

const disableEditTooltip = (
  <Tooltip id='toolTipImage'>You do not have permission to edit this record. Please contact your admin.</Tooltip>
)

const phoneNumberFormatter = (numbers) =>
  numbers.length ? [...new Set(numbers.map((entry) => entry.phone_number))].join(', ') : null

export class IdDisplay extends PureComponent {
  renderSubmitButton = () => {
    const { props } = this
    const { mainData } = props

    if (
      mainData.state === TX_STATUS_POST_PROCESSING ||
      mainData.state === TX_STATUS_CUSTOMER_REVIEW ||
      (mainData.state === TX_STATUS_HOLD && mainData.phase === TX_PHASE_IDENTITY)
    ) {
      return (
        <button
          onClick={() => props.openProcessTransactionStartModalDialog(props.id)}
          className='btn btn-warning m-l-sm'
        >
          <i className='fa fa-play-circle' /> Process Transaction
        </button>
      )
    }

    return null
  }

  renderEditButton = () => {
    const { props } = this
    const { user, data } = props
    if (user) {
      if (user.groups.includes('clerks')) {
        return (
          <OverlayTrigger placement='top' overlay={disableEditTooltip}>
            <Button bsPrefix='btn btn-info' type='button' style={{ opacity: 0.5 }}>
              <i className='fa fa-paste' /> Edit
            </Button>
          </OverlayTrigger>
        )
      } else {
        return (
          <Button
            disabled={data.state === TX_STATUS_PROCESSING}
            bsPrefix='btn btn-info'
            type='button'
            onClick={() => props.history.push(`/wizard/${props.id}`)}
          >
            <i className='fa fa-paste' /> Edit
          </Button>
        )
      }
    }
  }

  componentDidMount() {
    this.props.getUser()
  }

  render() {
    const props = this.props
    const { data, phoneCount, govIdDocCount, passportDocCount } = props
    const passportDoc =
      data.identity_documents && data.identity_documents.find((doc) => doc.document_type === 'passport')
    const frontDoc = data.identity_documents && data.identity_documents.find((doc) => doc.document_type === 'front')
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div className='ibox-title round-corner-box-top'>
          <h5>Transaction ID: {props.id}</h5>
        </div>
        <div className='ibox-content table-responsive round-corner-box-bottom'>
          <Table striped bordered hover>
            <tbody>
              <tr>
                <th style={{ width: '25%' }}>Name</th>
                <td>
                  {data.first_name || data.last_name || data.middle_name
                    ? (data.first_name || '') + ' ' + (data.middle_name || '') + ' ' + (data.last_name || '')
                    : ''}
                </td>
              </tr>
              <tr>
                <th>Phone Numbers</th>
                <td>
                  {phoneNumberFormatter(data.identity_phone_numbers)}{' '}
                  {phoneCount && phoneCount !== 1 ? ` (${phoneCount} duplicate numbers)` : ''}
                </td>
              </tr>
              <tr>
                <th>Email Addresses</th>
                <td>
                  {data.identity_emails.length
                    ? data.identity_emails.map((entry, i) => (i === 0 ? entry.email : ', ' + entry.email))
                    : null}
                </td>
              </tr>
              <tr>
                <th>Date Created</th>
                <td>{formatTimeString(props.mainData.created, DATE_FORMAT)}</td>
              </tr>
              <tr>
                <th>Country (from ID):</th>
                <td>
                  {data.country_code}{' '}
                  {data.country_code && (
                    <ReactCountryFlag
                      countryCode={data.country_code}
                      svg
                      style={{
                        width: '1.5em',
                        height: '1.5em',
                        marginLeft: 5,
                      }}
                      title={data.country_code}
                    />
                  )}
                </td>
              </tr>
              <tr>
                <th className='td-nowrap'>Country (user selected):</th>
                <td>
                  {data.selected_country_code}{' '}
                  {data.selected_country_code && (
                    <ReactCountryFlag
                      countryCode={data.selected_country_code}
                      svg
                      style={{
                        width: '1.5em',
                        height: '1.5em',
                        marginLeft: 5,
                      }}
                      title={data.selected_country_code}
                    />
                  )}
                </td>
              </tr>
              <tr>
                <th>Birth Date</th>
                <td>{data.birth_date}</td>
              </tr>
              <tr>
                <th>Gov ID / Drivers License</th>
                <td>
                  {data.drivers_license}{' '}
                  {govIdDocCount && govIdDocCount !== 1 ? ` (${govIdDocCount} duplicate numbers)` : ''}
                </td>
              </tr>
              {passportDoc && passportDoc.expiration_date && (
                <tr>
                  <th>Passport Expiration Date</th>
                  <td>{passportDoc.expiration_date}</td>
                </tr>
              )}
              {frontDoc && frontDoc.expiration_date && (
                <tr>
                  <th>Document Expiration Date</th>
                  <td>{frontDoc.expiration_date}</td>
                </tr>
              )}
              <tr>
                <th>Passport Number</th>
                <td>
                  {data.passport_number}{' '}
                  {passportDocCount && passportDocCount !== 1 ? ` (${passportDocCount} duplicate numbers)` : ''}
                </td>
              </tr>
              {data.resident_number && (
                <tr>
                  <th>Resident Number</th>
                  <td>{data.resident_number}</td>
                </tr>
              )}

              <tr>
                <th>Notes</th>
                <td>{data.notes}</td>
              </tr>
            </tbody>
          </Table>
          <div className='text-center'>
            {this.renderEditButton()}
            {this.renderSubmitButton()}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.getUser.user,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUser,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IdDisplay))
